import React from 'react'
import { GlobalStore, globalStore } from './store/Stores'

export const useStores = (): GlobalStore => React.useContext(globalStore)
